<script lang="ts" setup>
import { Button } from '~ds/components/ui/button';
import { useI18n } from 'vue-i18n';

const emit = defineEmits<{
  backHome: [];
}>();

const { t } = useI18n();
</script>

<template>
  <div data-testid="onboarding-too-young-step" class="flex justify-center">
    <Button
      data-testid="onboarding-too-young-home"
      variant="secondary"
      size="lg"
      type="button"
      class="w-full"
      @click="emit('backHome')"
    >
      {{ t('unified.onboarding.tooYoungBackHome') }}
    </Button>
  </div>
</template>
